import { render, staticRenderFns } from "./IconDetails.vue?vue&type=template&id=39e84a3e&"
import script from "./IconDetails.vue?vue&type=script&lang=js&"
export * from "./IconDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports